import { render, staticRenderFns } from "./ProductDataTable.vue?vue&type=template&id=ea993e20&scoped=true"
import script from "./ProductDataTable.vue?vue&type=script&lang=js"
export * from "./ProductDataTable.vue?vue&type=script&lang=js"
import style0 from "./ProductDataTable.vue?vue&type=style&index=0&id=ea993e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea993e20",
  null
  
)

export default component.exports